export default "__VITE_ASSET__BechOUYe__"